import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

interface Feature {
  key: string;
  icon: string;
  image: string;
  imageSize: string;
  tint: string;
  shadow: string;
  border: string;
  hasExtra?: boolean;
}

const ASSETS = '/assets/images/home';

@Component({
  imports: [TranslocoDirective],
  selector: 'app-home-why-choose',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './why-choose.html',
})
export class WhyChoose {
  protected readonly features: Feature[] = [
    {
      key: 'meaningfulLearning',
      icon: `${ASSETS}/icons/meaningful-experiential.png`,
      image: `${ASSETS}/photos/meaningful-experiential.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-green-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-green-200)]',
      border: 'border-green-100/60',
    },
    {
      key: 'readyMaterials',
      icon: `${ASSETS}/icons/ready-to-use.png`,
      image: `${ASSETS}/photos/ready-to-use.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-sky-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-sky-200)]',
      border: 'border-sky-100/60',
    },
    {
      key: 'photoVideo',
      icon: `${ASSETS}/icons/photo-video.png`,
      image: `${ASSETS}/photos/photo-video.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-amber-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-amber-200)]',
      border: 'border-amber-100/60',
    },
    {
      key: 'socialContent',
      icon: `${ASSETS}/icons/post-event-social.png`,
      image: `${ASSETS}/photos/post-event-social.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-violet-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-violet-200)]',
      border: 'border-violet-100/60',
    },
    {
      key: 'onSiteTeam',
      icon: `${ASSETS}/icons/dedicate-on-site.png`,
      image: `${ASSETS}/photos/dedicate-on-site.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-teal-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-teal-200)]',
      border: 'border-teal-100/60',
    },
    {
      key: 'certificates',
      icon: `${ASSETS}/icons/certificates-badge.png`,
      image: `${ASSETS}/photos/certificates-badge.webp`,
      imageSize: 'h-28 sm:h-32',
      tint: 'bg-[color-mix(in_oklab,var(--color-yellow-50)_55%,white)]',
      shadow: 'shadow-[0_0_12px_-3px_var(--color-yellow-200)]',
      border: 'border-yellow-100/60',
      hasExtra: true,
    },
  ];
}
